const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const classNames = require('classnames');
const storage = require('utilities/storage');

// @ utils
const { formatText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');
const { HYPHEN } = require('constants/index');
const { getUrlDocumentByEncodedId } = require('utilities/pdfDocumentsHelper');
const { buildLinks } = require('utilities/fundsHelper');

// @ commons
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { StarsRating } = require('commonsComponents/starsRating');
const RiskLevelBar = require('components/broker/commons/riskLevelBar/riskLevelBar');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @ components
const { RadioButton } = require('commonsComponents/radioButton');
const BrokerMiFIDUSPersonLinkButton = require('mifid/components/brokerMiFIDUSPersonLinkButton/brokerMiFIDUSPersonLinkButton');

// @constants
const { BROKER_SEARCH_RESULTS_TOTAL_RISK, DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT, PRODUCT_TYPE_FUND, TOTAL_STAR_COUNT } = require('constants/index');

class BrokerAdvancedSearchFundsResultsRow extends React.Component {
    constructor(props) {
        super(props);
        this.handleCheckChange = this.handleCheckChange.bind(this);
        this.handleProductSelect = this.handleProductSelect.bind(this);
    }

    shouldComponentUpdate(next) {
        return this.props.isActive !== next.isActive || this.props.item.get('watchlistId') !== next.item.get('watchlistId');
    }

    componentWillUnmount() {
        storage.localStorage.set(DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT, 1);
    }

    handleCheckChange(e) {
        this.props.saveCheckedList(e.target.id);
    }

    handlePdfDownload(pdfUrl){
        return ()=>window.open(pdfUrl, '_blank');
    }

    handleProductSelect() {
        const { item } = this.props;
        const product = {
            instrumentId: item.get('secId'),
            label: item.get('name'),
            customInstitutionSecurityID: item.get('CustomInstitutionSecurityID'),
            isin: item.get('ISIN'),
            currency: item.get('currency')
        };

        this.props.onHandleProductSelect(product);
    }


    wrappedFormatAmount(...args) {
        const result = formatAmount(...args);

        if (result === '') {
            return HYPHEN;
        } else {
            return result;
        }
    }

    buildRow() {
        const { item, isActive, isModal, rowIndex, watchlistEnabled } = this.props;

        const notAvailableText = formatText('broker-searchResultsNotAvailableData');
        const buyLabel = watchlistEnabled ? formatText(`broker-searchResultsWatchListBuyLabel`) : formatText(`broker-searchResultsBuyLabel`);
        const buyButtonSize = watchlistEnabled ? "small" : "regular";
        const yesText = formatText('broker-traspassableTextYes');
        const noText = formatText('common-no');

        const TOTAL_STARS = TOTAL_STAR_COUNT;

        const risk = item.get('risk')
            ? (<RiskLevelBar
                riskLevel={item.get('risk')}
                maxLevel={BROKER_SEARCH_RESULTS_TOTAL_RISK}
              />)
            : notAvailableText;
        const isin = item.get('ISIN');
        const miccode = item.get('secId');
        const productName = item.get('name');
        const traspassableText = item.get('traspassableFund') ? yesText : noText;
        const buyUrl =
            '/myprofile/broker/buyInvestmentFunds/' + item.get('CustomInstitutionSecurityID');

        const cardUrl = buildLinks(isin);
        const buttonText = formatText('brokerExternalTransferFundStep2-selectButton');
        const watchlistId = item.get('watchlistId');
        const productKey = item.get('productKey');
        const starIconClasses = classNames('broker-search-results__star', {
            'broker-search-results__star--disabled': !watchlistId
        });
        let button;
        let checkbox;

        if (this.props.isModal) {
            if (this.props.embeddedSearch) {
                checkbox = (
                    <OKTableCell className="broker-search-results__table-first-column">
                        <RadioButton
                            className="broker-search-results__radio"
                            onChange={this.handleProductSelect}
                            isChecked={isActive}
                            id={item.get('CustomInstitutionSecurityID')}
                            name={item.get('CustomInstitutionSecurityID')}
                            value={item.get('CustomInstitutionSecurityID')}
                        />
                    </OKTableCell>
                );
            } else {
                button = (
                    <OKButton modifier="secondary" onClick={this.handleProductSelect}>
                        {buttonText}
                    </OKButton>
                );
            }
        } else {
            button = (
                <React.Fragment>
                    <BrokerMiFIDUSPersonLinkButton
                        modifier="secondary"
                        to={buyUrl}
                        size={buyButtonSize}
                        isinId={item.get('ISIN')}
                    >
                        {buyLabel}
                    </BrokerMiFIDUSPersonLinkButton>
                </React.Fragment>
            );
            checkbox = (
                <OKTableCell className="broker-search-results__table-first-column">
                    <OKCheckbox
                        extraClass="broker-search-results__checkbox--hide"
                        idName={item.get('secId')}
                        onChange={this.handleCheckChange}
                        value={isActive}
                    />
                </OKTableCell>
            );
        }
        const watchlistButton = (
            <span>
                <OKButton
                    modifier="ghost"
                    size="small"
                    autoHeight={true}
                    onClick={() => { !watchlistId ? this.props.onWatchlistClick(isin, miccode, PRODUCT_TYPE_FUND, productKey) : this.props.deleteProductFromList(watchlistId, isin, miccode, productName, watchlistId, false, PRODUCT_TYPE_FUND, productKey)}}
                >
                    <i className={starIconClasses}></i>
                </OKButton>
            </span>
        );

        const watchListToolTipInitialVal = Number(storage.localStorage.get(DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT)) === 0;
        const isTooltipVisible = (rowIndex == 0 && watchListToolTipInitialVal && watchlistEnabled);
        const watchlistBtnTooltip = watchlistEnabled && (
            <OKTooltip
                target={watchlistButton}
                content="brokerWatchList-brokerWatchList_tooltip"
                isVisible={isTooltipVisible}
            />
        );

        const url = getUrlDocumentByEncodedId(item.get('KiidDocument'));
        const fundName = item.get('name');
        const nameElement = isModal
            ? fundName
            : <OKLink to={cardUrl}>{fundName}</OKLink>;

        return (
            <OKTableRow>
                {checkbox}
                <OKTableCell className="broker-search-results__table-cell broker-search-results__table-cell--bold">
                    {nameElement}
                </OKTableCell>
                <OKTableCell>
                    {item.get('category') || notAvailableText}
                </OKTableCell>
                <OKTableCell className="broker-search-results__table-cell--capitalize">
                    {traspassableText}
                </OKTableCell>
                <OKTableCell alignment="center">
                    <StarsRating
                        total={TOTAL_STARS}
                        actual={item.get('rating')}
                        customClassName="broker-search-results__stars-rating"
                    />
                </OKTableCell>
                <OKTableCell alignment="center">
                    {risk}
                </OKTableCell>
                <OKTableCell alignment="right">
                    {this.wrappedFormatAmount(item.get('ytd'))}
                </OKTableCell>
                <OKTableCell alignment="right">
                    {this.wrappedFormatAmount(item.get('aYear'))}
                </OKTableCell>
                <OKTableCell alignment="right">
                    {this.wrappedFormatAmount(item.get('threeYears'))}
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    className="broker-search-results__table-header-cell--plan-five-year"
                >
                    {this.wrappedFormatAmount(item.get('fiveYears'))}
                </OKTableCell>
                <OKTableCell alignment="center">
                    <OKButton
                        modifier="task"
                        size="small"
                        loaderColor="dark"
                        loaderSize="small"
                        onClick={this.handlePdfDownload(url)}>
                        <i className="icon icon-descargar broker-search-results__icon-descargar" />
                    </OKButton>
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    className="broker-search-results__table-cell--action"
                >
                    <div className="broker-search-results__action-group">
                        {watchlistBtnTooltip}
                        {button}
                    </div>
                </OKTableCell>
            </OKTableRow>
        );
    }

    buildRowForExternalFunds(){
        const { item, isModal, isActive } = this.props;

        const isin = item.get('ISIN');
        const cardUrl = buildLinks(isin);
        const fundName = item.get('name');
        const nameElement = isModal
            ? fundName
            : <OKLink to={cardUrl}>{fundName}</OKLink>;

        const isinSection = `${formatText('broker-searchResultsIsin')}: ${isin}`;
        return(
            <OKTableRow>
                <OKTableCell>
                    <RadioButton
                        className="broker-search-results__radio"
                        onChange={this.handleProductSelect}
                        isChecked={isActive}
                        id={item.get('ISIN')}
                        name={item.get('ISIN')}
                        value={item.get('ISIN')}
                    />
                </OKTableCell>
                <OKTableCell onClick={this.handleProductSelect} className="broker-search-results__table-cell">
                    <div className="broker-search-results__table-cell--bold">{nameElement}</div>
                    <div className="broker-search-results__isin-section">{isinSection}</div>
                </OKTableCell>
            </OKTableRow>
        )
    }
    render(){
        const { isExternalFundsTransfer } = this.props
        return isExternalFundsTransfer ? this.buildRowForExternalFunds() : this.buildRow();
    }
}

BrokerAdvancedSearchFundsResultsRow.propTypes = {
    item: PropTypes.object,
    checkedList: PropTypes.object,
    saveCheckedList: PropTypes.func,
    isActive: PropTypes.bool,
    isModal: PropTypes.bool,
    embeddedSearch: PropTypes.bool,
    onWatchlistClick: PropTypes.func,
    onHandleProductSelect: PropTypes.func,
    deleteProductFromList: PropTypes.func,
    rowIndex: PropTypes.number,
    watchlistEnabled: PropTypes.bool,
    isExternalFundsTransfer: PropTypes.bool,
    immExternalTransferFund: PropTypes.object
};

module.exports = BrokerAdvancedSearchFundsResultsRow;
